import React, { Fragment, FunctionComponent, useEffect, useRef, useState } from 'react';
import './mpinFail.scss'
import { useHistory } from 'react-router-dom';
import mpinErr from '../../assets/images/mpin-err.svg';
import AxisButton from '../../components/button/button';	
import Text from '../../components/typography/typgraphy';	
import { APP_URLS } from '../../constants/constants';	
import { getTransactionIdFromURL } from '../../constants/utils';	
import { logoutUser } from '../../constants/utils';
import { MPIN_FAIL_HOME_GA, MPIN_FAIL_PAGELOAD_PARAM, MPIN_FAIL_PAGELOAD_VPV, pushDataLayer } from '../../constants/gaConstants';

const MpinFail = () => {
    const history = useHistory();
    const queryParams = new URLSearchParams(window.location.search);
    const errCode = queryParams.get('err');
    const [errMsg, setErrMsg] = useState('')
    const [errMsgTwo, setErrMsgTwo] = useState('')
    const transactionId = getTransactionIdFromURL()

    useEffect(() => {
        if(errCode == '115'){
            pushDataLayer(MPIN_FAIL_PAGELOAD_VPV('mpin-expired', 'mpin expired', transactionId))
            pushDataLayer(MPIN_FAIL_PAGELOAD_PARAM('mpin expired', transactionId))

            setErrMsg(`Your Mpin has expired. Please reset your new Mpin from your Axis Mobile App.`)
            setErrMsgTwo(`Reinitiate transaction from partner portal after reset.`)
        }
        else if(errCode == '116'){
            pushDataLayer(MPIN_FAIL_PAGELOAD_VPV('2f-auth-not-done', '2f-auth-not-done', transactionId))
            pushDataLayer(MPIN_FAIL_PAGELOAD_PARAM('2f-auth-not-done', transactionId))

            setErrMsg(`Please login to your Axis Mobile App. After clicking on any product you will be prompted to complete second level authentication.`)
            setErrMsgTwo(`Reinitiate transaction from partner portal after authentication.`)
        }
        else if(errCode == '117'){
            pushDataLayer(MPIN_FAIL_PAGELOAD_VPV('registration terminated', 'registration terminated', transactionId))
            pushDataLayer(MPIN_FAIL_PAGELOAD_PARAM('registration terminated', transactionId))

            setErrMsg(`Your registration has been terminated. Please contact the nearest branch for physical verification.`)
            setErrMsgTwo(`Your registration will be reactivated after branch verification.`)
        }
        else if(errCode == '118'){
            pushDataLayer(MPIN_FAIL_PAGELOAD_VPV('mobile not registered', 'mobile not registered', transactionId))
            pushDataLayer(MPIN_FAIL_PAGELOAD_PARAM('mobile not registered', transactionId))

            setErrMsg(`You are not registered. Please register on Axis Mobile app.`)
            setErrMsgTwo(`Reinitiate transaction from partner portal after registration.`)
        }
        else if(errCode == '119'){
            pushDataLayer(MPIN_FAIL_PAGELOAD_VPV('mobile app not active', 'mobile app not active', transactionId))
            pushDataLayer(MPIN_FAIL_PAGELOAD_PARAM('mobile app not active', transactionId))

            setErrMsg(`Please activate Axis Mobile App from your mobile device. `)
            setErrMsgTwo(`Reinitiate transaction from partner portal after activation and registration of your MPIN. `)
        }
        else if(errCode == '105'){
            pushDataLayer(MPIN_FAIL_PAGELOAD_VPV('mpin locked', 'mpin locked', transactionId))
            pushDataLayer(MPIN_FAIL_PAGELOAD_PARAM('mpin locked', transactionId))

            setErrMsg(` Your account has locked. Please unlock your account by logging into Axis Mobile app.`)
            setErrMsgTwo(`Reinitiate transaction from partner portal on success.`)
        }
        else if(errCode == '9000'){
            pushDataLayer(MPIN_FAIL_PAGELOAD_VPV('back arrow error', 'back arrow error', transactionId))
            pushDataLayer(MPIN_FAIL_PAGELOAD_PARAM('back arrow error', transactionId))

            setErrMsg(`You are about to logout. Please reinitiate the transaction from partner portal.`)	
            setErrMsgTwo('')	
        }
    },[errCode])

    const handleHome = () => {	
        
        if(errCode == '9000'){
            logoutUser()
            pushDataLayer(MPIN_FAIL_HOME_GA('back arrow error', transactionId))	
        }	
        else{	
            if(errCode == '115'){
                pushDataLayer(MPIN_FAIL_HOME_GA('mpin expired', transactionId))
            }
            else if(errCode == '116'){
                pushDataLayer(MPIN_FAIL_HOME_GA('2f-auth-not-done', transactionId))
            }
            else if(errCode == '117'){
                pushDataLayer(MPIN_FAIL_HOME_GA('registration terminated', transactionId))
            }
            else if(errCode == '118'){
                pushDataLayer(MPIN_FAIL_HOME_GA('mobile not registered', transactionId))
            }
            else if(errCode == '119'){
                pushDataLayer(MPIN_FAIL_HOME_GA('mobile app not active', transactionId))
            }
            else if(errCode == '105'){
                pushDataLayer(MPIN_FAIL_HOME_GA('mpin locked', transactionId))
            }
            logoutUser(APP_URLS.LOGIN.replace(":txnId", transactionId))	
            // history.push({		
            //     pathname: `${APP_URLS.LOGIN.replace(":txnId", transactionId)}`,		
            // })	
        }			
    }

    return(
        <Fragment>
            <div className='mpin-err'>
                <div className='mpin-err__icon'><img src={mpinErr}/></div>
                <div className='mpin-err__text'>{errCode=='9000'?"":'Login Failed'} {errCode? <div><div>{errMsg}</div><div>{errMsgTwo}</div></div> : "Please re-initiate journey again from partner portal"}</div>	
                <div className='mpin-err__error-home-btn'>		
                    <AxisButton onClick={handleHome} className='err-home-button' customStyle={"submit-btn-primary"} variant="contained">		
                        <Text className={"submit-btn-text"}>Home</Text>		
                    </AxisButton>		
                </div>
            </div>
        </Fragment>
    )
}

export default MpinFail;

